import classes from './ProjectTag.module.scss';

const ProjectTag = ({ tag }) => {
  return (
    <span className={classes.Tag}>{tag}</span>
  );
};

export default ProjectTag;